/**
 * Database Keys for Order Collection
 */

export const ORDER_KEYS = {
  ORDER_SHORTCODE: {
    label: 'Order Shortcode',
    value: 'Order_shortcode',
  },
  PLANNED_DELIVERY_DATE: {
    label: 'Planned Delivery Date',
    value: 'Planned_DeliveryDate',
  },
  PREPARED_BY: { label: 'Prepared By', value: 'Prepared_by' },
  DELIVERY_PROVIDER: { label: 'Delivery Provider', value: 'Delivery_provider' },
  ORDER_VALUE_EXCLUV_TAX: {
    label: 'Order Value Excluv Tax',
    value: 'order_value_excluv_tax',
  },
  VAT_AMOUNT: { label: 'Vat Amount', value: 'vat_amount' },
  SERVICE_FEE: { label: 'Service Fee', value: 'service_fee' },
  DELIVERY_FEE: { label: 'Delivery Fee', value: 'delivery_fee' },
  CUSTOMER_NAME: { label: 'Customer Name', value: 'customer_Name' },
  CUSTOMER_ADDRESS: { label: 'Customer Address', value: 'customer_Address' },
  CUSTOMER_ADDRESS2: { label: 'Customer Address2', value: 'customer_Address2' },
  AREA: { label: 'Area', value: 'Area' },
  CITY: { label: 'City', value: 'City' },
  COUNTRY: { label: 'Country', value: 'Country' },
  LATITUDE: { label: 'Latitude', value: 'latitude' },
  LONGITUDE: { label: 'Longitude', value: 'longitude' },
  CONTACT: { label: 'Contact', value: 'Contact' },
}

export const ORDER_TABLE_FIELDS = {
  ...ORDER_KEYS,
  ORDER_NO: { label: 'Order No', value: 'order_no' },
  STORE_CODE: { label: 'Store Code', value: 'Store_code' },
  PRODUCTS: { label: 'Products', value: 'products' },
  PAYMENT: { label: 'Payment', value: 'payment' },
  ORDER_PLACE_DATETIME: {
    label: 'Order Place Datetime',
    value: 'order_place_datetime',
  },
  ORDER_VALUE_INCLV_TAX: {
    label: 'Order Value Inclv Tax',
    value: 'order_value_inclv_tax',
  },
  AGGREGATOR_CODE: { label: 'Aggregator Code', value: 'Aggregator_Code' },
  STORE_NAME: { label: 'Store Name', value: 'storeName' },
  DELIVERY_SLOT: { label: 'Delivery Slot', value: 'deliverySlot' },
  DELIVERY_METHOD: { label: 'Delivery Method', value: 'deliveryMethod' },
  STATUS: { label: 'Order Status', value: 'status' },
  ERP_SYNC: { label: 'ERP Sync', value: 'erpSync' },
  LAST_MILE: { label: 'Last Mile', value: 'lastMile' },
  LAST_MILE_SYNC: { label: 'Last Mile Sync', value: 'lastMileSync' },
  INVOICE_NO: { label: 'Invoice Number', value: 'invoiceNo' },
  AGGREGATOR_PRICE: { label: 'Aggregator Price', value: 'systemPrice' },
  ORDER_POSTING_DATE: { label: 'Order Posting Date', value: 'createdAt' },
}

export const ORDER_STATUS = {
  WAITING_FOR_DRIVER: 'Waiting for Driver',
  AGGREGATOR_LM: 'Aggregator LM',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered',
  DELIVERY_FAILED: 'Delivery Failed',
  CANCELED: 'Canceled',
}

export const ORDER_STATUS_CLASSES = {
  [ORDER_STATUS.WAITING_FOR_DRIVER]: 'bg-yellow-200  text-gray-900',
  [ORDER_STATUS.AGGREGATOR_LM]: 'bg-green-300 text-gray-900',
  [ORDER_STATUS.OUT_FOR_DELIVERY]: 'bg-blue-600  text-white',
  [ORDER_STATUS.DELIVERED]: 'bg-green-300 text-gray-900',
  [ORDER_STATUS.DELIVERY_FAILED]: 'bg-red-500  text-white',
  [ORDER_STATUS.CANCELED]: 'bg-gray-300  text-gray-900',
}
